import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { FormattedMessage } from 'react-intl';
import ModalActionCreator from 'action_creators/modal';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import $ from 'jquery';
import Form from '../form';
import './index.scss';

const ModalContentComponent = createReactClass({
  displayName: 'TourPage-ContactGuide-ModalContent',

  mixins: [StoreInterestMixin],

  propTypes: {
    guideId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    tourId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    guidePictureUrl: PropTypes.string,
    isCompany: PropTypes.bool,
    tourName: PropTypes.string,
  },

  getInitialState() {
    return {
      messageSent: false,
    };
  },

  getDefaultProperties() {
    return {
      guidePictureUrl: null,
      isCompany: false,
    };
  },

  getStoreInterests() {
    return {
      messageSent: 'contact.sendingCompleted',
    };
  },

  _isCompany() {
    return this.props.isCompany === true;
  },

  _contactAside() {
    return (
      <div className="TourPage-ContactGuide-aside">
        <h3 className="ContactModal-header plugins">
          <FormattedMessage
            id="INQUIRE_ABOUT"
            defaultMessage="Inquire About"
            description="Header text for the contact modal asking about a tour"
          />
        </h3>
        <div className="ContactModal-guide-name">{this.props.tourName}</div>
        <hr className="ContactModal-hr plugins" />
        <p>
          <FormattedMessage
            defaultMessage="Please contact us with any questions and we will follow up with you."
            description="Informational text encouraging users to ask questions"
          />
        </p>
      </div>
    );
  },

  _contactForm() {
    return (
      <Form
        tourId={this.props.tourId}
        guideId={this.props.guideId}
        isCompany={this.props.isCompany}
      />
    );
  },

  _renderContactSend() {
    return (
      <div className="TourPage-ContactGuide-ModalContent">
        {this._contactForm()}
        {this._contactAside()}
      </div>
    );
  },

  _closeModal(e) {
    e.preventDefault();
    $('body').removeClass('modal-open');
    ModalActionCreator.hide();
  },

  _renderSendSuccess() {
    return (
      <div className="TourPage-ContactGuide-ModalContent-success">
        <div>
          <FormattedMessage
            defaultMessage="Thank you for your interest!"
            description="Thank you message after submitting contact form"
          />
        </div>
        <div>
          <FormattedMessage
            defaultMessage="We will get back to you shortly."
            description="Message indicating quick response after contact form submission"
          />
        </div>
        <button
          className="ui button large TourPage-ContactGuide-submit-button brand-bg"
          onClick={this._closeModal}
        >
          <FormattedMessage
            id="OKAY"
            defaultMessage="Okay"
            description="Button text to close the success modal"
          />
        </button>
      </div>
    );
  },

  render() {
    return this.state.messageSent
      ? this._renderSendSuccess()
      : this._renderContactSend();
  },
});

export default ModalContentComponent;
